import { useState, useCallback } from 'react';
import { getAllFAQ } from '../services/api/methods.ts';
import { FAQ, GetAllPromotionsResult } from '../services/api/types.ts';

export const useFAQ = () => {
    const [faq, setFAQ] = useState<FAQ[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const loadFAQ = useCallback(async () => {
        setLoading(true);
        setError('');

        try {
            const result = await getAllFAQ();
            setFAQ(result.FAQ);
        } catch (err: any) {
            setError('Ошибка при загрузке часто задаваемых вопросов');
            console.error('Ошибка при загрузке часто задаваемых вопросов:', err);
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        faq,
        loading,
        error,
        loadFAQ,
        setFAQ,
        setError
    };
};
